import { useCallback, useMemo, useState } from "react";

import { ModalProps, useVolatileCallback } from "@examspark/common-ui";

type UseModalOptions = {
  isInitiallyOpen?: boolean;
  onRequestClose?: () => void | boolean | Promise<void | boolean>;
};

export const useModal = (options?: boolean | UseModalOptions) => {
  if (typeof options === "boolean") {
    options = { isInitiallyOpen: options };
  }

  const [isOpen, setIsOpen] = useState(!!options?.isInitiallyOpen);

  const onRequestClose = useVolatileCallback(options?.onRequestClose);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return useMemo(() => {
    const modalProps: Pick<ModalProps, "isOpen" | "onRequestClose"> = {
      isOpen: isOpen,
      onRequestClose: () => {
        Promise.resolve(onRequestClose?.()).then((shouldClose) => {
          if (shouldClose !== false) {
            setIsOpen(false);
          }
        });
      },
    };

    return {
      isOpen,
      open,
      close,
      setIsOpen,
      modalProps,
    };
  }, [close, isOpen, onRequestClose, open]);
};
